import ReservationsTable from "./table";

const ActiveReservations = () => {
    return (
        <>
            <div className="main-container">
                <ReservationsTable />
            </div>
        </>
    );
};

export default ActiveReservations;
